export default __webpack_public_path__ + "media/eduShelleyMann.e0d12a04.jpg";